import React from "react";
import './Info.css';

function Info () {
    return (
        <div className="info">
            <h1 className="info_title">
                My history with programming
            </h1>
            <div className="info_information_container">
                <div className="info_information_introduction">
                    <h2 className="info_information_introduction_header">
                        Background Information
                    </h2>
                    <div className="info_information_introduction_paragraphs">
                        <p className="info_information_introduction_paragraph_one">
                            Ever since I was young, the world of coding has been my playground. I distinctly remember the thrill of my first lines of code, a fascination that evolved into a passion over the years. Throughout high school, I eagerly embraced the opportunity to turn that passion into tangible creations, initiating and completing small coding projects that ranged from simple applications to interactive websites. These early forays into the world of programming not only honed my technical skills but also fostered a creative problem-solving mindset.
                        </p>
                        <p className="info_information_introduction_paragraph_two">
                            Now, as I embark on my first year at the University of Delaware, I am thrilled to take my coding journey to new heights. The academic environment here provides me with the resources and challenges I need to expand my knowledge and push the boundaries of what I can create. The transition from high school projects to more substantial endeavors is an exciting leap, and I am relishing the opportunity to contribute to the larger coding community. My journey so far has been a testament to my unwavering commitment to continuous learning and the boundless possibilities that coding presents.
                        </p>
                    </div>
                </div>
                <div className="info_lower_categories">
                    <div className="info_skills">
                        <h2 className="info_skills_heading">
                            Skills and Expertise
                        </h2>
                        <ul className="skills_list">
                            <li className="skill">
                                Data Analysis
                            </li>
                            <li className="skill">
                                Web Development (HTML, CSS, JavaScript)
                            </li>
                            <li className="skill">
                                Game Development (C#)
                            </li>
                            <li className="skill">
                                First-Year Student at University of Delaware
                            </li>
                            <li className="skill">
                                Team Leadership
                            </li>
                            <li className="skill">
                                Problem Solving
                            </li>
                            <li className="skill">
                                Python-Advanced
                            </li>
                            <li className="skill">
                                JavaScript-Advanced
                            </li>
                            <li className="skill">
                                C#-Intermediate
                            </li>
                        </ul>
                    </div>
                    <div className="info_mission_statement">
                        <h2 className="info_mission_statement_header">
                            Mission Statement
                        </h2>
                        <p className="info_mission_statement_text">
                            My mission is to further humanity through technology. I believe in integrity, honesty, adaptablity, and most importantly accountablility. I am dedicated to further my knowlage in the field of comuter science by constantly learning new things, while also having sucess in the industry. I strive to make the world a better place and am committed to sticking to my morals in every project or role I undertake.
                        </p>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default Info;